import React, { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CircularProgress, Option, Select } from '@mui/joy'
import { AppContext, useAppSettingsContext } from '../../../mtska-frontend-app-scaffolding'
import { Icon } from 'src/mtska-frontend-app-component/assets'
import { LegalEntityAvatar } from '../Snippet'
import { useLegalEntityOptions } from 'src/mtska-frontend-app-scaffolding/app/app.hooks'

export const LegalEntitySelect = () => {
    const { t } = useTranslation();

    const { appConfiguration } = useContext(AppContext);
    const { settings, setSettingsKey } = useAppSettingsContext();
    const [filterByLegalEntity, setFilterByLegalEntity] = useState(settings?.selectedLegalEntity?.id)

    const { legalEntityOptions } = useLegalEntityOptions()

    const selectedOption = legalEntityOptions && legalEntityOptions.find((option) => option.id === filterByLegalEntity);

    const onChange = (e, id) => {
        if (e && id !== filterByLegalEntity) {
            setFilterByLegalEntity(id);
            setSettingsKey('selectedLegalEntity', { id });
        }
    }

    // CHI TOCCA MUORE
    let label = t('alllegalentity');
    let name = t('∞');
    if (appConfiguration?.legalEntitySelector?.active && filterByLegalEntity && selectedOption && selectedOption.name !== 'all') {
        label = selectedOption.name;
        name = selectedOption.name;
    }

    return (
        <Box className="legalentity-menu">
            <Box className="legalentity-icon">
                <LegalEntityAvatar name={name} url={selectedOption?.logo?.url} size='squared' />
            </Box>
            {appConfiguration?.legalEntitySelector?.active === false &&
                <Box className="legalentity-name">
                    <span className="label">{t('legalentities')}</span>
                    <span className="value">{label}</span>
                </Box>
            }

            {/* {appConfiguration?.legalEntitySelector?.active &&
                <Box className="legalentity-list">
                    <Select
                        autoComplete="off"
                        className="form-element-field form-element-field-select"
                        id="input-select-strategy"
                        name="input-select-strategy"
                        onChange={onChange}
                        slotProps={{ listbox: { sx: { maxHeight: '300px', placement: 'bottom-end' } } }}
                        value={filterByLegalEntity || ''}
                        variant="outlined"
                    >
                        {appConfiguration?.legalEntitySelector?.canSeeAllButton &&
                            <Option key={-1} value={'all'}>{t('All')}</Option>
                        }
                        
                        {legalEntityOptions && legalEntityOptions.map((legalentity, k) => (
                            <Option key={k} value={legalentity.id}>{legalentity.name}</Option>
                        ))}
                    </Select>
                    <Icon icon="faChevronRight" className="selector-icon" />
                </Box>
            } */}
        </Box>
    )
}
